/** @format */

import axios from "axios";
import { API_PARAMS } from "../constants/api";

const apiClient = axios.create({
  baseURL: API_PARAMS.BASE_URL,
});

export const triggerClient = axios.create({
  baseURL: API_PARAMS.TRIGGER_URL,
});

export default apiClient;
